import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { SearchBarContext } from './SearchBarContext'

export const SearchBarMiniHeaderContent = () => {
  const { t } = useTranslation(['home', 'common'])

  const { raceType, location, formattedDateRange } =
    useContext(SearchBarContext)

  return !raceType?.label && !location?.name && !formattedDateRange ? (
    <Typography pl={{ md: 2 }} variant="body2" noWrap>
      {t('common:header.searchPlaceholder')}
    </Typography>
  ) : (
    <Stack>
      {raceType && (
        <Typography fontWeight={600} pl={{ md: 2 }} variant="body2">
          {raceType.label}
        </Typography>
      )}
      {location || formattedDateRange ? (
        <Typography fontSize={12} pl={{ md: 2 }} variant="body2">
          {formattedDateRange && formattedDateRange}
          {formattedDateRange && location ? '・' : ''}
          {location && location.name}
        </Typography>
      ) : null}
    </Stack>
  )
}
